import { Link } from "react-router-dom";

const stats = [
  { value: "5", label: "影片分类" },
  { value: "36+", label: "精选条目" },
  { value: "每日", label: "内容整理" },
  { value: "0", label: "注册门槛" },
];

const points = [
  { icon: "ri-layout-grid-line", text: "按电影、剧集、纪录片、短片与动画分类聚合，入口清晰不迷路。" },
  { icon: "ri-filter-3-line", text: "支持题材、地区、年代与排序组合筛选，缩小选择范围。" },
  { icon: "ri-file-text-line", text: "每部影片提供主演、导演、时长与剧情简介等结构化资料。" },
];

export default function IntroSection() {
  return (
    <section className="grid grid-cols-1 items-center gap-6 rounded-lg border border-background-200 bg-background-100/60 p-5 md:gap-10 md:p-8 lg:grid-cols-2">
      <div className="order-2 lg:order-1">
        <span className="flex items-center gap-1.5 text-[11px] uppercase tracking-[0.2em] text-secondary-700">
          <span className="h-1 w-1 rounded-full bg-secondary-500" />
          About the library
        </span>
        <h2 className="mt-2 font-heading text-xl font-semibold leading-snug text-foreground-950 md:text-[26px]">
          把分散的免费影片资源，
          <br className="hidden sm:block" />
          整理成一份好用的清单
        </h2>
        <p className="mt-3 text-sm leading-relaxed text-foreground-600">
          黄色片免费看是一个影片资源聚合与浏览平台。我们不提供播放与下载，只把公开可查的影片资料按类别整理好，
          让你在浏览、筛选与搜索的过程中更快做决定，少走弯路。
        </p>

        <ul className="mt-5 space-y-2.5">
          {points.map((point) => (
            <li key={point.icon} className="flex items-start gap-2.5 text-sm text-foreground-700">
              <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-md bg-background-50 text-primary-600">
                <i className={`${point.icon} text-sm`} />
              </span>
              <span className="leading-relaxed">{point.text}</span>
            </li>
          ))}
        </ul>

        <div className="mt-6 flex flex-wrap items-center gap-2.5">
          <Link
            to="/about"
            className="flex items-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
          >
            了解平台说明 <i className="ri-arrow-right-line" />
          </Link>
          <Link
            to="/category/documentary"
            className="flex items-center gap-1.5 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-4 py-2.5 text-sm text-foreground-700 transition-colors hover:border-primary-400 hover:text-primary-600"
          >
            先去看看纪录片
          </Link>
        </div>
      </div>

      <div className="order-1 lg:order-2">
        <div className="relative w-full overflow-hidden rounded-lg">
          <img
            src="https://readdy.ai/api/search-image?query=Editorial%20still%20life%20of%20a%20warm%20minimal%20shelf%20filled%20with%20vintage%20film%20reels%20and%20paper%20notebooks%2C%20soft%20afternoon%20sunlight%20casting%20long%20shadows%20on%20a%20beige%20wall%2C%20muted%20amber%20and%20cream%20palette%2C%20grainy%20analog%20photography%2C%20calm%20composition%2C%20no%20text&width=900&height=700&seq=home-about-library&orientation=squarish"
            alt="影片资源整理示意"
            title="黄色片免费看 - 影片资源分类整理"
            className="h-[240px] w-full object-cover object-top md:h-[320px]"
          />
          <div className="absolute bottom-3 left-3 right-3 flex items-center justify-between rounded-md bg-background-50/95 px-3.5 py-2.5">
            <div className="flex items-center gap-2 text-xs text-foreground-600">
              <i className="ri-check-double-line text-base text-primary-500" />
              资料持续整理中
            </div>
            <span className="text-[11px] text-foreground-400">更新于 2024.11</span>
          </div>
        </div>

        <div className="mt-3 grid grid-cols-2 gap-2.5 sm:grid-cols-4">
          {stats.map((item) => (
            <div
              key={item.label}
              className="rounded-lg border border-background-200 bg-background-50 px-3 py-3 text-center"
            >
              <p className="font-heading text-lg font-semibold text-primary-600">{item.value}</p>
              <p className="mt-1 text-[11px] text-foreground-500">{item.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}